import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardLayout from './components/DashboardLayout';
import ExecutiveCockpit from './pages/ExecutiveCockpit';
import StrategyTracker from './pages/StrategyTracker';
import SupervisoryIntel from './pages/SupervisoryIntel';
import GreenFinance from './pages/GreenFinance';
import OwnOperations from './pages/OwnOperations';
import DigitalTwin from './pages/DigitalTwin';
import EnvironmentalPerformance from './pages/EnvironmentalPerformance';
import AdminPanel from './pages/AdminPanel';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-surface-default"><div className="animate-pulse text-brand-primary font-heading text-xl">Loading...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-surface-default"><div className="animate-pulse text-brand-primary font-heading text-xl">Loading...</div></div>;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
        <Route index element={<ExecutiveCockpit />} />
        <Route path="strategy" element={<StrategyTracker />} />
        <Route path="supervisory" element={<SupervisoryIntel />} />
        <Route path="green-finance" element={<GreenFinance />} />
        <Route path="operations" element={<OwnOperations />} />
        <Route path="digital-twin" element={<DigitalTwin />} />
        <Route path="environmental" element={<EnvironmentalPerformance />} />
        <Route path="admin" element={<AdminPanel />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
